import { createContext, useContext } from "react";
import type { AttachmentDocument } from "@/features/files/AttachmentPreview";

/** Opens an attachment in a workspace document tab. Only a workspace page has
 * tabs to open into, so outside one this is null and attachments keep their
 * in-place behaviour. */
export const AttachmentOpenerContext = createContext<((attachment: AttachmentDocument) => void) | null>(null);

export function useAttachmentOpener() {
  return useContext(AttachmentOpenerContext);
}
